/**
 * Detects the device type based on user agent
 * @returns {string} 'iphone' | 'android' | 'other'
 */
export const detectDeviceType = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  
  // Check for iPhone
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'iphone';
  }
  
  // Check for Android
  if (/android/i.test(userAgent)) {
    return 'android';
  }
  
  // Default to other
  return 'other';
};

/**
 * Checks if the device is mobile (not desktop)
 * @returns {boolean}
 */
export const isMobileDevice = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
};



